import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

export default function LoadingButton({
	children,
	isLoading = false,
	...props
}) {
	return (
		<Button disabled={isLoading} {...props}>
			{children}

			{isLoading && (
				<CircularProgress
					size={24}
					sx={{
						position: 'absolute',
						top: '50%',
						left: '50%',
						marginTop: '-12px',
						marginLeft: '-12px',
					}}
				/>
			)}
		</Button>
	);
}

LoadingButton.propTypes = {
	children: PropTypes.node.isRequired,
	isLoading: PropTypes.bool,
};
